export default __webpack_public_path__ + "static/media/ticket-discount.faf08805.svg";